import { TRACKPAD_WHEEL_DELTA_MAX_PX, TRACKPAD_WHEEL_SESSION_MS } from "./constants";

export const isSceneGraphSiteNode = (node) =>
  node?.type === "site" || node?.type === "attachment_site";

export const isSceneGraphTypeHiddenInView = (type, effectiveHidden) =>
  effectiveHidden.has(type) || (type === "attachment_site" && effectiveHidden.has("site"));

/** True when a one-finger pan can start from this target (background / passive diagram chrome). */
export const sceneGraphPanGestureTargetIsBackground = (target) => {
  if (!(target instanceof Element)) return false;
  if (target.closest("[data-scene-selectable-node='true']")) return false;
  if (target.closest("[data-scene-graph-no-pan='true']")) return false;
  return true;
};

export const sceneGraphMiddlePanGestureTargetIsAllowed = (target) => {
  if (!(target instanceof Element)) return false;
  return !target.closest("[data-scene-graph-no-pan='true']");
};

export function isLikelyTrackpadPanWheel(event, lastTrackpadWheelAt) {
  if (!event || event.ctrlKey || event.metaKey) return false;
  if (event.deltaMode !== 0) return false;

  const now = performance.now();
  if (now - lastTrackpadWheelAt < TRACKPAD_WHEEL_SESSION_MS) return true;

  const absX = Math.abs(event.deltaX || 0);
  const absY = Math.abs(event.deltaY || 0);
  if (absX > 0) return true;

  return (
    absY > 0 &&
    absY < TRACKPAD_WHEEL_DELTA_MAX_PX &&
    (!Number.isInteger(event.deltaY) || absY % 1 !== 0 || absY < 50)
  );
}

export function getSceneGraphSvgPoint(svg, clientX, clientY) {
  if (!svg || typeof svg.createSVGPoint !== "function") return null;
  const ctm = svg.getScreenCTM?.();
  if (!ctm) return null;
  const point = svg.createSVGPoint();
  point.x = clientX;
  point.y = clientY;
  return point.matrixTransform(ctm.inverse());
}
